import CommonErrorImage from 'assets/images/commonErrorBG.svg';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

type ErrorFallbackProps = {
  message: string;
};

export const ErrorFallbackRoot = styled('div', { name: 'ErrorFallbackRoot' })({
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
});

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ message }) => {
  return (
    <ErrorFallbackRoot>
      <CommonErrorImage />
      <Typography variant="h1">{message}</Typography>
    </ErrorFallbackRoot>
  );
};
